import { v4 as uuid } from 'uuid';
import type { FetchProactiveAIOptions, ProactiveAIRequest, ProactiveAIResponse } from './types.tsx';

/**
 * Fetches proactive nudge suggestions
 * @param options - Configuration options for the request
 * @returns Promise resolving to the nudge suggestion response
 */
export const fetchProactiveNudgeSuggestion = async (
	options: FetchProactiveAIOptions,
): Promise<ProactiveAIResponse> => {
	const { triggerType, triggerDetails, triggerId = uuid() } = options;

	const requestPayload: ProactiveAIRequest = {
		ai_feature_input: {
			triggers: [
				{
					trigger_id: triggerId,
					trigger_type: triggerType,
					trigger_details: triggerDetails,
				},
			],
		},
	};

	const response = await fetch('/gateway/api/assist/api/ai/v2/ai-feature/proactive', {
		method: 'POST',
		credentials: 'include',
		headers: {
			'Content-Type': 'application/json',
			'X-Product': 'jira',
			'X-Experience-Id': 'proactive-ai-rovo-button',
		},
		body: JSON.stringify(requestPayload),
	});

	if (!response.ok) {
		const errorResponse = await response.json();
		throw new Error(errorResponse.errorMessage || `HTTP error! status: ${response.status}`);
	}

	const data: ProactiveAIResponse = await response.json();
	return data;
};
